/** @jsx jsx */
import React, { useContext, useEffect, useMemo } from 'react'
import { jsx } from '@emotion/core'
import { connect } from 'react-redux'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'
import MonthlyPerfDataContext, {
  MonthlyPerfDataProvider,
} from './MonthlyPerfDataContext'
import {
  getMonthlyPerfData,
  saveMonthlyPerfData,
  qaMonthlyPerfData,
} from 'api/pgads'
import { Button, DatePicker, Tabs, message, Modal } from 'antd'
import { SpinContext, DatePickerContext, ErrorContext } from 'context'
import DataPanel, { updateAuxilData } from './DataPanel'
import SharedMeter from './SharedMeter'
import DataErrorDialog from 'core/component/JcTmpErrorDialog'
import R from 'ramda'
const { MonthPicker } = DatePicker

export const showErrorMessage = ({ unitname }) =>
  Modal.error({
    title: unitname + ' Total Auxiliaries Mismatch',
    content: (
      <div>
        Online Auxliaries + Offline Auxliaries must equal Total Auxiliaries for
        Unit {unitname}
        . <br />
        Please modify the Online or Offline Auxliaries so that their sum matches
        the Total Auxliaries.
      </div>
    ),
    width: '700px',
  })

const MonthlyPerfData = ({ apiTargetInfo, envConfig, actionPermits }) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const {
    setAllData,
    allData = {},
    currentData,
    setCurrentData,
    activeTab,
    setActiveTab,
    setNonEditDataMap,
    dataError,
    setDataError,
    setMeterData,
    // nonEditDataMap,
  } = useContext(MonthlyPerfDataContext)
  // const [meterData, setMeterData] = useState([])
  const { setError } = useContext(ErrorContext)

  const { authGodMode } = envConfig

  const onChange = date => setSelectedDate(date.endOf('month'))

  const retrieve = ({ date = selectedDate, isChangeActiveTab = true }) => {
    setSpinning(true)
    getMonthlyPerfData(apiTargetInfo)(date).fork(setError, data => {
      setSpinning(false)
      setAllData(data)
      isChangeActiveTab && setActiveTab(data.unitLists[0].unitname)
      const detailData = (data.mainData || [])
        .filter(d => !!d.unit)
        .map(d => ({
          [d.unitname]: updateAuxilData(d),
        }))

      const detailDataMap = R.reduce((a, b) => ({ ...a, ...b }), {}, detailData)
      let nonEditDataMap = (data.nonEditDetails || []).map(d => ({
        [d.unitname]: d,
      }))
      nonEditDataMap = R.reduce((a, b) => ({ ...a, ...b }), {}, nonEditDataMap)

      setCurrentData(detailDataMap)
      setNonEditDataMap(nonEditDataMap)
      setMeterData([...data.meterDetails] || [])
    })
  }

  useEffect(
    _ => {
      setAllData({})
      setCurrentData({})
      setNonEditDataMap({})
      setMeterData([])
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedDate]
  )

  const retrieveDataAfterSave = _ => {
    setDataError([])
    retrieve({ date: selectedDate, isChangeActiveTab: false })
  }

  const saveData = _ => {
    setSpinning(true)
    saveMonthlyPerfData(apiTargetInfo)(
      { ...currentData[activeTab], action: 'N' },
      selectedDate
    ).fork(setError, errorDdata => {
      setSpinning(false)
      setDataError(errorDdata)
      if (errorDdata.length === 0) {
        message.success('Data Saved for ' + activeTab)
        retrieveDataAfterSave()
      }
    })
  }

  // const qaValidateData3 = _ => {
  //   const data = currentData[activeTab]
  //   const readData = nonEditDataMap[activeTab]

  //   const roTtotl = readData.roTotalAux
  //   const online = data.onlineAux
  //   const offline = data.offlineAux
  //   const newTotal = parseFloat(online) + parseFloat(offline)

  //   if (roTtotl !== newTotal) {
  //     // message.error('parseFloat(online) + parseFloat(offline)', 20)
  //     showErrorMessage({ unitname: data.unitname })
  //     return
  //   }
  //   return true
  // }

  // convenSteam is totalAux
  const qaValidateData = _ => {
    const data = currentData[activeTab] || {}
    const readData = currentData[activeTab] || {}

    let roTtotl = readData.convenSteam || 0
    roTtotl = parseFloat(roTtotl)
    const online = data.onlineAux || 0
    const offline = data.offlineAux || 0
    const newTotal = parseFloat(online) + parseFloat(offline)

    if (roTtotl !== newTotal) {
      // message.error('parseFloat(online) + parseFloat(offline)', 20)
      showErrorMessage({ unitname: data.unitname })
      return
    }
    setSpinning(true)
    qaMonthlyPerfData(apiTargetInfo)(
      [{ ...currentData[activeTab], action: 'N' }],
      selectedDate,
      'N'
    ).fork(setError, errorDdata => {
      setSpinning(false)
      setDataError(errorDdata)
      if (errorDdata.length === 0) retrieveDataAfterSave()
    })
  }

  const qaValidateAllData = _ => {
    const checkAll = (allData.unitLists || []).map(ul => {
      const data = currentData[ul.unitname] || { onlineAux: 0, offline: 0 }
      const readData = currentData[ul.unitname] || { convenSteam: 0 }

      const online = data.onlineAux || 0
      const offline = data.offlineAux || 0
      const newTotal = parseFloat(online) + parseFloat(offline)
      let roTotal = readData.convenSteam || 0
      roTotal = parseFloat(roTotal)

      return {
        roTotal: parseFloat(roTotal),
        newTotal,
        unitname: ul.unitname,
        online,
        offline,
        isValid: newTotal === roTotal,
      }
    })

    const inValid = checkAll.find(f => !f.isValid)
    if (inValid) {
      showErrorMessage({ unitname: inValid.unitname })
      return
    }

    setSpinning(true)

    const data = (allData.unitLists || [])
      .map(ul => ({
        ...currentData[ul.unitname],
        action: 'N',
      }))
      .filter(f => !!f.unit)

    qaMonthlyPerfData(apiTargetInfo)(data, selectedDate, 'Y').fork(
      setError,
      errorDdata => {
        setSpinning(false)

        setDataError(errorDdata)
        if (errorDdata.length === 0) retrieveDataAfterSave()
      }
    )
  }

  const hasWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MONTHLY_PERF_DATA_ADMIN],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <DataErrorDialog
        visible={dataError.length > 0}
        errors={dataError}
        closeErrorPrompt={_ => setDataError([])}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          Monthly Performance Data
        </Title>
        <MonthPicker
          onChange={onChange}
          placeholder="Select month"
          value={selectedDate}
          format="MMMM-YYYY"
        />
        <Button
          icon="database"
          loading={spinning}
          onClick={retrieve}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>
        {hasWritePermission && (
          <Button
            onClick={qaValidateData}
            style={{ marginLeft: '20px', width: '100px' }}
            type="ghost"
            disabled={
              !hasWritePermission || Object.keys(currentData).length <= 0
            }
          >
            QA
          </Button>
        )}
        {hasWritePermission && (
          <Button
            onClick={qaValidateAllData}
            style={{ marginLeft: '20px', width: '100px' }}
            type="ghost"
            disabled={
              !hasWritePermission || Object.keys(currentData).length <= 0
            }
          >
            QA All
          </Button>
        )}
      </CriteriaRow>
      <FullHeightSizer heightOffset={210}>
        {({ height }) => (
          <Content
            css={{ height: height - 20, paddingTop: '10px' }}
            className="card-container"
          >
            <Tabs
              type="card"
              activeKey={activeTab}
              onChange={setActiveTab}
              tabPosition="top"
              // renderTabBar={(props, DefaultTabBar) => (
              //   <DefaultTabBar
              //     {...props}
              //     style={{ display: 'flex' }}
              //     // panels={(allData.unitLists || []).map(ul => (
              //     //   <Tabs.TabPane
              //     //     key={ul.utility + ul.unit}
              //     //     tab={ul.unitname}
              //     //     style={{
              //     //       backgroundColor: 'blue',
              //     //     }}
              //     //   />
              //     // ))}
              //   />
              //  )}
              tabBarStyle={{ padding: '10px' }}
            >
              {(allData.unitLists || []).map(ul => (
                <Tabs.TabPane
                  forceRender
                  key={ul.unitname}
                  tab={
                    <h3
                      style={{
                        padding: '0px',
                        color:
                          (currentData[ul.unitname] || {}).isValidated === 'Y'
                            ? 'green'
                            : 'red',
                      }}
                    >
                      {ul.unitname}
                    </h3>
                  }
                >
                  <DataPanel
                    {...ul}
                    apiTargetInfo={apiTargetInfo}
                    date={selectedDate}
                    saveData={saveData}
                    retrieveDataAfterSave={retrieveDataAfterSave}
                    hasWritePermission={hasWritePermission}
                  />
                </Tabs.TabPane>
              ))}
              {allData.meterDetails && (
                <Tabs.TabPane key="meter" tab={<b>Shared Meter</b>}>
                  <SharedMeter
                    apiTargetInfo={apiTargetInfo}
                    date={selectedDate}
                    saveData={saveData}
                    // meterData={meterData}
                    hasWritePermission={hasWritePermission}
                  />
                </Tabs.TabPane>
              )}
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

const MonthlyPerfDatacreen = props => (
  <MonthlyPerfDataProvider>
    <MonthlyPerfData {...props} />
  </MonthlyPerfDataProvider>
)

export default connect(mapStateToProps)(MonthlyPerfDatacreen)
